'use client';

import { useUser } from '@clerk/nextjs';
import { useState } from 'react';
import { Bug } from 'lucide-react';

export function UserInfoDebug() {
  const { isLoaded, isSignedIn, user } = useUser();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isLoaded) {
    return (
      <div className="fixed top-2 right-4 sm:right-6 lg:right-8 bg-gray-800 text-white p-2 rounded-lg text-xs">
        <Bug className="w-4 h-4 animate-pulse" />
      </div>
    );
  }

  const userId = user?.id ? `user-${user.id}` : 'Not authenticated';

  return (
    <div className="fixed top-2 right-4 sm:right-6 lg:right-8 z-50">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="bg-gray-800 text-white p-2 rounded-lg hover:bg-gray-700 transition-colors"
        title="Debug User Info"
      >
        <Bug className="w-4 h-4" />
      </button>
      
      {isExpanded && (
        <div className="absolute top-full right-0 mt-2 bg-gray-800 text-white p-4 rounded-lg text-xs w-80 shadow-xl">
          <h3 className="font-bold mb-2 text-sm">Debug: User Information</h3>
          <div className="space-y-1 font-mono">
            <div><span className="text-gray-400">Status:</span> {isSignedIn ? '✅ Signed In' : '❌ Not Signed In'}</div>
            <div><span className="text-gray-400">User ID:</span> {user?.id || 'None'}</div>
            <div><span className="text-gray-400">Memory ID:</span> {userId}</div>
            <div><span className="text-gray-400">Username:</span> {user?.username || 'None'}</div>
            <div><span className="text-gray-400">Email:</span> {user?.primaryEmailAddress?.emailAddress || 'None'}</div>
            <div><span className="text-gray-400">Name:</span> {user?.fullName || user?.firstName || 'None'}</div>
          </div>
          <div className="mt-3 pt-3 border-t border-gray-700">
            <p className="text-gray-400">This is the user ID used for memory storage in Mem0.</p>
          </div>
        </div>
      )}
    </div>
  );
} 